<div class="custom-params-dialog">

    <!-- Encabezado -->
    <div class="dialog-header">
        <div class="dialog-title">
            <mat-icon>tune</mat-icon>
            <div>
                <h2 mat-dialog-title>Ubicaciones y especialidades</h2>
                <span class="subtitle">{{ user.name }}</span>
            </div>
        </div>
        <button mat-icon-button (click)="onClose()" matTooltip="Cerrar" [disabled]="isSaving()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-divider></mat-divider>

    <mat-dialog-content class="dialog-body">

        @if (isLoading()) {
            <div class="loading-row">
                <mat-spinner diameter="32"></mat-spinner>
                <span>Cargando información...</span>
            </div>
        } @else {
            <form [formGroup]="form" class="params-form">

                <!-- Sitios (places) -->
                <div class="select-all-row">
                    <button mat-stroked-button type="button" [disabled]="availablePlaces().length === 0"
                            (click)="toggleAll('places', availablePlaces())">
                        <mat-icon>{{ allSelected('places', availablePlaces()) ? 'deselect' : 'select_all' }}</mat-icon>
                        {{ allSelected('places', availablePlaces()) ? 'Quitar todas las ubicaciones' : 'Seleccionar todas las ubicaciones' }}
                    </button>
                </div>
                <mat-form-field appearance="outline">
                    <mat-label>Ubicaciones</mat-label>
                    <mat-select formControlName="places" multiple>
                        @for (place of availablePlaces(); track place.id) {
                            <mat-option [value]="place.id">{{ place.name }}</mat-option>
                        }
                    </mat-select>
                    <mat-icon matPrefix>place</mat-icon>
                    @if (availablePlaces().length === 0) {<mat-hint>No hay ubicaciones en el catálogo.</mat-hint>} @else {
                        <mat-hint>{{ form.value.places?.length || 0 }} seleccionado(s)</mat-hint>
                    }
                </mat-form-field>

                <!-- Especialidades (specialties) -->
                <div class="select-all-row">
                    <button mat-stroked-button type="button" [disabled]="availableSpecialties().length === 0"
                            (click)="toggleAll('specialties', availableSpecialties())">
                        <mat-icon>{{ allSelected('specialties', availableSpecialties()) ? 'deselect' : 'select_all' }}</mat-icon>
                        {{ allSelected('specialties', availableSpecialties()) ? 'Quitar todas las especialidades' : 'Seleccionar todas las especialidades' }}
                    </button>
                </div>
                <mat-form-field appearance="outline">
                    <mat-label>Especialidades</mat-label>
                    <mat-select formControlName="specialties" multiple>
                        @for (specialty of availableSpecialties(); track specialty.id) {
                            <mat-option [value]="specialty.id">{{ specialty.name }}</mat-option>
                        }
                    </mat-select>
                    <mat-icon matPrefix>medical_services</mat-icon>
                    @if (availableSpecialties().length === 0) {<mat-hint>No hay especialidades en el catálogo.</mat-hint>} @else {
                        <mat-hint>{{ form.value.specialties?.length || 0 }} seleccionada(s)</mat-hint>
                    }
                </mat-form-field>

            </form>
        }

    </mat-dialog-content>

    <mat-divider></mat-divider>

    <mat-dialog-actions class="dialog-actions">
        <button mat-button type="button" (click)="onClose()" [disabled]="isSaving()">
            Cancelar
        </button>
        <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="onSave()"
            [disabled]="isSaving() || isLoading()"
        >
            @if (isSaving()) {<mat-spinner diameter="18"></mat-spinner>} @else {<mat-icon>save</mat-icon>}
            <span>Guardar cambios</span>
        </button>
    </mat-dialog-actions>
</div>
